<template>
  <svg
    width="325"
    height="264"
    viewBox="0 0 325 264"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M201.119 41.4387C194.417 28.0477 175.917 26.5009 167.084 38.5929L56.9709 189.335C48.1762 201.375 55.1733 218.458 69.8869 220.869L272.024 253.992C288.134 256.631 300.45 239.902 293.144 225.303L201.119 41.4387Z"
      fill="#F1F5F6"
    />
    <mask
      id="mask0_444_287"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="-32"
      y="61"
      width="221"
      height="227"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M184.528 113.734L175.875 121.855L185.755 125.537L184.528 113.734Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M167.049 107.22L158.396 115.34L168.276 119.022L167.049 107.22Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M149.569 100.705L140.917 108.826L150.796 112.508L149.569 100.705Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M132.089 94.1911L123.437 102.311L133.317 105.993L132.089 94.1911Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M113.85 87.3937L105.198 95.5139L115.078 99.1959L113.85 87.3937Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M96.3708 80.8794L87.7186 88.9996L97.5983 92.6816L96.3708 80.8794Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.891 74.3651L70.2387 82.4854L80.1184 86.1674L78.891 74.3651Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.4115 67.8508L52.7593 75.971L62.639 79.653L61.4115 67.8508Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.9321 61.3364L35.2798 69.4567L45.1595 73.1387L43.9321 61.3364Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.08 134.757L178.427 142.877L188.307 146.559L187.08 134.757Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M169.6 128.242L160.948 136.362L170.828 140.044L169.6 128.242Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M152.12 121.728L143.468 129.848L153.348 133.53L152.12 121.728Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.641 115.214L125.989 123.334L135.869 127.016L134.641 115.214Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.162 108.699L108.509 116.819L118.389 120.501L117.162 108.699Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M99.6823 102.185L91.0301 110.305L100.91 113.987L99.6823 102.185Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.2028 95.671L73.5506 103.791L83.4303 107.473L82.2028 95.671Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M64.723 89.1563L56.0707 97.2765L65.9504 100.959L64.723 89.1563Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.244 82.6422L38.5917 90.7624L48.4714 94.4444L47.244 82.6422Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.7645 76.1278L21.1123 84.2481L30.992 87.9301L29.7645 76.1278Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M171.392 148.982L162.74 157.102L172.619 160.784L171.392 148.982Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M153.912 142.467L145.26 150.587L155.14 154.269L153.912 142.467Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M136.433 135.953L127.78 144.073L137.66 147.755L136.433 135.953Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118.953 129.439L110.301 137.559L120.181 141.241L118.953 129.439Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M100.714 122.641L92.0616 130.761L101.941 134.443L100.714 122.641Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M83.2344 116.127L74.5822 124.247L84.4619 127.929L83.2344 116.127Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.755 109.613L57.1027 117.733L66.9824 121.415L65.755 109.613Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.2755 103.098L39.6233 111.218L49.503 114.9L48.2755 103.098Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.7957 96.5839L22.1434 104.704L32.0231 108.386L30.7957 96.5839Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M173.943 170.004L165.291 178.124L175.171 181.806L173.943 170.004Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M156.464 163.49L147.812 171.61L157.691 175.292L156.464 163.49Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M138.985 156.975L130.332 165.096L140.212 168.778L138.985 156.975Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M121.505 150.461L112.852 158.581L122.732 162.264L121.505 150.461Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.025 143.947L95.3731 152.067L105.253 155.749L104.025 143.947Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M86.5463 137.433L77.8941 145.553L87.7738 149.235L86.5463 137.433Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M69.0664 130.918L60.4142 139.038L70.2939 142.72L69.0664 130.918Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.5874 124.404L42.9352 132.524L52.8149 136.206L51.5874 124.404Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.1076 117.889L25.4553 126.01L35.335 129.692L34.1076 117.889Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6277 111.375L7.97544 119.496L17.8551 123.178L16.6277 111.375Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M158.256 184.229L149.603 192.349L159.483 196.031L158.256 184.229Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M140.776 177.715L132.124 185.835L142.004 189.517L140.776 177.715Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M123.296 171.2L114.644 179.321L124.524 183.003L123.296 171.2Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M105.817 164.686L97.1648 172.806L107.044 176.488L105.817 164.686Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.5779 157.888L78.9256 166.009L88.8053 169.691L87.5779 157.888Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.098 151.375L61.4458 159.495L71.3255 163.177L70.098 151.375Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.6186 144.86L43.9663 152.98L53.846 156.662L52.6186 144.86Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.1391 138.346L26.4869 146.466L36.3666 150.148L35.1391 138.346Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6597 131.831L9.00742 139.952L18.8871 143.634L17.6597 131.831Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M160.807 205.252L152.155 213.372L162.035 217.054L160.807 205.252Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M143.328 198.738L134.676 206.858L144.555 210.54L143.328 198.738Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M125.848 192.223L117.196 200.343L127.076 204.025L125.848 192.223Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.369 185.709L99.7168 193.829L109.596 197.511L108.369 185.709Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.8894 179.194L82.2371 187.314L92.1168 190.996L90.8894 179.194Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M73.4099 172.68L64.7577 180.801L74.6374 184.483L73.4099 172.68Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.9305 166.166L47.2782 174.286L57.1579 177.968L55.9305 166.166Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.451 159.651L29.7988 167.772L39.6785 171.454L38.451 159.651Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.9712 153.137L12.3189 161.257L22.1986 164.939L20.9712 153.137Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.49215 146.623L-5.16009 154.743L4.71961 158.425L3.49215 146.623Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.12 219.476L136.468 227.597L146.347 231.279L145.12 219.476Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M127.64 212.962L118.987 221.082L128.867 224.764L127.64 212.962Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M110.16 206.448L101.508 214.568L111.388 218.25L110.16 206.448Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M92.681 199.934L84.0288 208.054L93.9085 211.736L92.681 199.934Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M74.4415 193.136L65.7892 201.256L75.669 204.938L74.4415 193.136Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.962 186.622L48.3098 194.742L58.1895 198.424L56.962 186.622Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.483 180.107L30.8308 188.227L40.7105 191.909L39.483 180.107Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.0031 173.593L13.3509 181.714L23.2306 185.396L22.0031 173.593Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.52328 167.079L-4.12897 175.199L5.75074 178.881L4.52328 167.079Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M147.671 240.499L139.019 248.619L148.899 252.301L147.671 240.499Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M130.192 233.985L121.539 242.105L131.419 245.787L130.192 233.985Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M112.712 227.471L104.06 235.591L113.94 239.273L112.712 227.471Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.2324 220.956L86.5801 229.076L96.4598 232.758L95.2324 220.956Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77.753 214.442L69.1007 222.562L78.9804 226.244L77.753 214.442Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.2735 207.928L51.6212 216.048L61.501 219.73L60.2735 207.928Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.7941 201.413L34.1418 209.533L44.0215 213.215L42.7941 201.413Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.3146 194.899L16.6624 203.019L26.5421 206.701L25.3146 194.899Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.83517 188.385L-0.817075 196.505L9.06263 200.187L7.83517 188.385Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M131.983 254.724L123.331 262.844L133.211 266.526L131.983 254.724Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M114.504 248.21L105.852 256.33L115.731 260.012L114.504 248.21Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.025 241.695L88.3727 249.816L98.2524 253.498L97.025 241.695Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M79.5446 235.181L70.8924 243.301L80.7721 246.983L79.5446 235.181Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.3051 228.383L52.6528 236.504L62.5325 240.186L61.3051 228.383Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.8256 221.869L35.1734 229.99L45.0531 233.672L43.8256 221.869Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.3466 215.355L17.6944 223.475L27.5741 227.157L26.3466 215.355Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.86673 208.841L0.214479 216.961L10.0942 220.643L8.86673 208.841Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M99.5759 262.718L90.9236 270.838L100.803 274.52L99.5759 262.718Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.0964 256.203L73.4442 264.324L83.3239 268.006L82.0964 256.203Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M64.617 249.689L55.9647 257.81L65.8444 261.492L64.617 249.689Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.1371 243.175L38.4849 251.295L48.3646 254.977L47.1371 243.175Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.6581 236.661L21.0058 244.781L30.8855 248.463L29.6581 236.661Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1791 230.146L3.52683 238.267L13.4065 241.949L12.1791 230.146Z"
        fill="#15232B"
      />
    </mask>
    <g mask="url(#mask0_444_287)">
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.491 110.705C105.254 93.7591 84.786 85.9777 72.6033 97.8215L12.5573 156.197C2.03853 166.423 5.74336 184.118 19.4809 189.265L85.5996 214.04C99.2594 219.159 113.627 208.404 112.564 193.855L106.491 110.705Z"
        fill="#F1F5F6"
      />
    </g>
    <mask
      id="mask1_444_287"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="14"
      y="-8"
      width="221"
      height="227"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M230.771 44.8175L222.118 52.9378L231.998 56.6198L230.771 44.8175Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M213.291 38.3032L204.639 46.4234L214.519 50.1054L213.291 38.3032Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M195.812 31.7885L187.159 39.9088L197.039 43.5908L195.812 31.7885Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.332 25.2744L169.68 33.3946L179.56 37.0766L178.332 25.2744Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M160.093 18.4769L151.441 26.5972L161.32 30.2792L160.093 18.4769Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M142.614 11.9626L133.961 20.0828L143.841 23.7648L142.614 11.9626Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M125.134 5.44838L116.482 13.5686L126.361 17.2506L125.134 5.44838Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M107.654 -1.06596L99.0021 7.05428L108.882 10.7363L107.654 -1.06596Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.175 -7.58031L81.5227 0.539933L91.4024 4.22194L90.175 -7.58031Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M233.323 65.8399L224.67 73.9602L234.55 77.6422L233.323 65.8399Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M215.843 59.3255L207.191 67.4457L217.07 71.1277L215.843 59.3255Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M198.363 52.8114L189.711 60.9316L199.591 64.6136L198.363 52.8114Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M180.884 46.297L172.232 54.4173L182.112 58.0993L180.884 46.297Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M163.405 39.7825L154.752 47.9027L164.632 51.5847L163.405 39.7825Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.925 33.2682L137.273 41.3885L147.153 45.0705L145.925 33.2682Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M128.446 26.7542L119.793 34.8745L129.673 38.5565L128.446 26.7542Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M110.966 20.2395L102.314 28.3598L112.193 32.0418L110.966 20.2395Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.4868 13.7254L84.8346 21.8457L94.7143 25.5277L93.4868 13.7254Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M76.0074 7.21108L67.3552 15.3313L77.2349 19.0133L76.0074 7.21108Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.635 80.065L208.983 88.1852L218.862 91.8672L217.635 80.065Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M200.155 73.5503L191.503 81.6706L201.383 85.3526L200.155 73.5503Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M182.676 67.0363L174.023 75.1566L183.903 78.8386L182.676 67.0363Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M165.196 60.522L156.544 68.6422L166.424 72.3242L165.196 60.522Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M146.957 53.7244L138.305 61.8447L148.184 65.5267L146.957 53.7244Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M129.477 47.2099L120.825 55.3301L130.705 59.0121L129.477 47.2099Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.998 40.6959L103.346 48.8161L113.225 52.4981L111.998 40.6959Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M94.5184 34.1812L85.8662 42.3014L95.7459 45.9834L94.5184 34.1812Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77.0385 27.6672L68.3863 35.7874L78.266 39.4694L77.0385 27.6672Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M220.186 101.087L211.534 109.207L221.414 112.889L220.186 101.087Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M202.707 94.573L194.055 102.693L203.934 106.375L202.707 94.573Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M185.228 88.0587L176.575 96.179L186.455 99.861L185.228 88.0587Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M167.747 81.5445L159.095 89.6647L168.975 93.3467L167.747 81.5445Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M150.268 75.0302L141.616 83.1504L151.496 86.8324L150.268 75.0302Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M132.789 68.5159L124.137 76.6362L134.017 80.3182L132.789 68.5159Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M115.309 62.0013L106.657 70.1215L116.537 73.8035L115.309 62.0013Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.8303 55.487L89.178 63.6073L99.0577 67.2893L97.8303 55.487Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.3504 48.9727L71.6982 57.0929L81.5779 60.7749L80.3504 48.9727Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.8705 42.4586L54.2183 50.5788L64.098 54.2608L62.8705 42.4586Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M204.498 115.312L195.846 123.433L205.726 127.115L204.498 115.312Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.019 108.798L178.367 116.918L188.246 120.6L187.019 108.798Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M169.539 102.284L160.887 110.404L170.767 114.086L169.539 102.284Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M152.06 95.7692L143.408 103.889L153.287 107.571L152.06 95.7692Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M133.821 88.9717L125.169 97.0919L135.048 100.774L133.821 88.9717Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.341 82.4578L107.689 90.578L117.568 94.26L116.341 82.4578Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M98.8614 75.9431L90.2092 84.0634L100.089 87.7454L98.8614 75.9431Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.382 69.4288L72.7298 77.549L82.6095 81.231L81.382 69.4288Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.9026 62.9147L55.2503 71.0349L65.13 74.7169L63.9026 62.9147Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M207.05 136.335L198.398 144.455L208.277 148.137L207.05 136.335Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M189.571 129.821L180.919 137.941L190.798 141.623L189.571 129.821Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M172.091 123.306L163.439 131.426L173.319 135.108L172.091 123.306Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M154.612 116.792L145.96 124.912L155.839 128.594L154.612 116.792Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M137.132 110.277L128.48 118.398L138.36 122.08L137.132 110.277Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M119.653 103.764L111.001 111.884L120.88 115.566L119.653 103.764Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M102.173 97.2491L93.5211 105.369L103.401 109.051L102.173 97.2491Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.6939 90.7345L76.0417 98.8548L85.9214 102.537L84.6939 90.7345Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M67.214 84.2202L58.5618 92.3404L68.4415 96.0224L67.214 84.2202Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.735 77.7058L41.0828 85.8261L50.9625 89.5081L49.735 77.7058Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M191.363 150.56L182.71 158.68L192.59 162.362L191.363 150.56Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M173.883 144.045L165.23 152.166L175.11 155.848L173.883 144.045Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M156.403 137.531L147.751 145.652L157.631 149.334L156.403 137.531Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M138.924 131.017L130.272 139.137L140.151 142.819L138.924 131.017Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M120.684 124.219L112.032 132.34L121.912 136.022L120.684 124.219Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M103.205 117.705L94.5527 125.825L104.432 129.507L103.205 117.705Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M85.7259 111.191L77.0737 119.311L86.9534 122.993L85.7259 111.191Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.246 104.677L59.5938 112.797L69.4735 116.479L68.246 104.677Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.7661 98.1619L42.1139 106.282L51.9936 109.964L50.7661 98.1619Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.914 171.583L185.262 179.703L195.142 183.385L193.914 171.583Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M176.435 165.068L167.782 173.188L177.662 176.87L176.435 165.068Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M158.955 158.554L150.303 166.674L160.182 170.356L158.955 158.554Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M141.475 152.039L132.823 160.16L142.703 163.842L141.475 152.039Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M123.996 145.525L115.344 153.645L125.223 157.327L123.996 145.525Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.516 139.011L97.8641 147.131L107.744 150.813L106.516 139.011Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.037 132.496L80.3847 140.617L90.2644 144.299L89.037 132.496Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.5575 125.982L62.9052 134.103L72.785 137.785L71.5575 125.982Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.078 119.468L45.4258 127.588L55.3055 131.27L54.078 119.468Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.5986 112.953L27.9464 121.074L37.8261 124.756L36.5986 112.953Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.226 185.807L169.574 193.927L179.454 197.609L178.226 185.807Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M160.747 179.293L152.095 187.413L161.974 191.095L160.747 179.293Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M143.268 172.779L134.616 180.899L144.495 184.581L143.268 172.779Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M125.788 166.264L117.135 174.385L127.015 178.067L125.788 166.264Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M107.548 159.467L98.8957 167.587L108.775 171.269L107.548 159.467Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.0685 152.953L81.4163 161.073L91.296 164.755L90.0685 152.953Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.5895 146.438L63.9373 154.559L73.817 158.241L72.5895 146.438Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.1096 139.924L46.4574 148.044L56.3371 151.726L55.1096 139.924Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.6306 133.409L28.9784 141.53L38.8581 145.212L37.6306 133.409Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M180.778 206.83L172.126 214.95L182.005 218.632L180.778 206.83Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M163.298 200.316L154.646 208.436L164.526 212.118L163.298 200.316Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.819 193.801L137.167 201.921L147.046 205.603L145.819 193.801Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M128.339 187.287L119.687 195.407L129.567 199.089L128.339 187.287Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M110.86 180.773L102.208 188.893L112.087 192.575L110.86 180.773Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.38 174.258L84.7277 182.378L94.6074 186.06L93.38 174.258Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M75.901 167.744L67.2487 175.864L77.1284 179.546L75.901 167.744Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.4219 161.23L49.7697 169.35L59.6494 173.032L58.4219 161.23Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.9416 154.715L32.2894 162.835L42.1691 166.517L40.9416 154.715Z"
        fill="#15232B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.4622 148.201L14.8099 156.321L24.6896 160.003L23.4622 148.201Z"
        fill="#15232B"
      />
    </mask>
    <g mask="url(#mask1_444_287)">
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M152.734 41.7881C151.497 24.8423 131.029 17.061 118.846 28.9047L58.8002 87.2801C48.2814 97.5062 51.9862 115.201 65.7238 120.349L131.843 145.124C145.502 150.242 159.87 139.487 158.807 124.938L152.734 41.7881Z"
        fill="#F1F5F6"
      />
    </g>
    <g filter="url(#filter0_d_444_287)">
      <path
        d="M33.8438 73.0349C34.3527 60.7011 44.4808 50.4139 56.7307 49.7883L228.959 40.993C241.487 40.3533 251.555 50.0404 251.456 62.6387L250.837 141.887C250.739 154.496 240.495 165.248 227.958 165.903L53.0642 175.036C40.2266 175.706 30.0265 165.547 30.5598 152.621L33.8438 73.0349Z"
        fill="#E2F3EB"
      />
      <mask
        id="mask2_444_287"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="30"
        y="23"
        width="222"
        height="153"
      >
        <path
          d="M33.8555 56.5546C34.2964 44.1944 44.4129 33.8399 56.6906 33.1821L228.931 23.954C241.481 23.2816 251.584 32.9761 251.485 45.5967L250.733 141.894C250.635 154.502 240.391 165.254 227.853 165.909L52.9326 175.043C40.1454 175.711 29.9641 165.631 30.4233 152.758L33.8555 56.5546Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_444_287)">
        <rect
          width="59.2966"
          height="20.4217"
          rx="10.2108"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 43.3321 61.0544)"
          fill="#FFFFFE"
        />
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.7502 64.2914L63.1571 63.5888C64.4735 63.5198 65.5141 64.5321 65.4814 65.8499C65.4488 67.1676 64.3552 68.2918 63.0388 68.3608L49.6319 69.0634C48.3155 69.1324 47.2749 68.1201 47.3076 66.8023C47.3402 65.4846 48.4338 64.3604 49.7502 64.2914Z"
          fill="#E2F3EB"
        />
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.7502 71.75L84.2118 70.0289C85.5282 69.9599 86.5688 70.9722 86.5361 72.29C86.5035 73.6077 85.4099 74.7319 84.0935 74.8009L49.6319 76.5219C48.3155 76.5909 47.2749 75.5786 47.3076 74.2609C47.3402 72.9431 48.4338 71.8189 49.7502 71.75Z"
          fill="#E2F3EB"
        />
        <rect
          width="135.078"
          height="103.831"
          rx="16.4942"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 109.144 57.6152)"
          fill="#FFFFFE"
        />
        <rect
          width="59.2966"
          height="20.4217"
          rx="10.2108"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 42.4282 88.5613)"
          fill="#FFFFFE"
        />
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.559 92.0371L61.9659 91.3345C63.2823 91.2655 64.3229 92.2778 64.2902 93.5956C64.2576 94.9133 63.164 96.0375 61.8476 96.1065L48.4407 96.8091C47.1244 96.8781 46.0837 95.8658 46.1164 94.548C46.1491 93.2303 47.2426 92.1061 48.559 92.0371Z"
          fill="#E2F3EB"
        />
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.559 99.4956L83.0206 97.7746C84.337 97.7056 85.3776 98.7179 85.345 100.036C85.3123 101.353 84.2187 102.478 82.9024 102.547L48.4407 104.268C47.1244 104.337 46.0837 103.324 46.1164 102.007C46.1491 100.689 47.2426 99.5646 48.559 99.4956Z"
          fill="#E2F3EB"
        />
        <rect
          width="59.2966"
          height="20.4217"
          rx="10.2108"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 41.5242 116.068)"
          fill="#FFFFFE"
        />
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.8573 119.783L62.2643 119.08C63.5806 119.011 64.6213 120.024 64.5886 121.341C64.5559 122.659 63.4623 123.783 62.146 123.852L48.739 124.555C47.4227 124.624 46.3821 123.611 46.4147 122.294C46.4474 120.976 47.541 119.852 48.8573 119.783Z"
          fill="#E2F3EB"
        />
        <rect
          width="59.2966"
          height="20.4217"
          rx="10.2108"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 40.6202 143.575)"
          fill="#FFFFFE"
        />
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.8573 127.241L83.319 125.52C84.6353 125.451 85.676 126.464 85.6433 127.781C85.6106 129.099 84.517 130.223 83.2007 130.292L48.739 132.013C47.4227 132.082 46.3821 131.07 46.4147 129.752C46.4474 128.435 47.541 127.31 48.8573 127.241Z"
          fill="#E2F3EB"
        />
        <rect
          width="119.331"
          height="60.5269"
          rx="16.4942"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 116.598 64.6101)"
          fill="#E2F3EB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M122.046 83.7461C122.105 85.0556 123.22 86.0605 124.536 85.9906L152.459 84.5073C153.774 84.4375 154.793 83.3192 154.734 82.0098V82.0098C154.675 80.7003 153.56 79.6954 152.244 79.7653L124.321 81.2485C123.006 81.3184 121.987 82.4366 122.046 83.7461V83.7461Z"
          fill="#B3E0D0"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M122.146 92.3958C122.205 93.7032 123.318 94.7066 124.632 94.637L172.585 92.0937C173.899 92.024 174.916 90.9077 174.857 89.6003V89.6003C174.798 88.2929 173.685 87.2895 172.371 87.3592L124.418 89.9024C123.104 89.9721 122.087 91.0884 122.146 92.3958V92.3958Z"
          fill="#B3E0D0"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M123.862 123.913C123.862 123.913 128.064 102.404 144.951 101.505C161.839 100.607 163.439 115.219 177.722 108.708C192.005 102.197 193.64 86.3312 208.283 87.7887C222.925 89.2461 227.532 118.396 227.532 118.396L123.862 123.913Z"
          fill="#00AEC8"
        />
        <rect
          width="119.331"
          height="21.8979"
          rx="10.949"
          transform="matrix(0.987016 -0.0515788 -0.0325133 0.98935 114.734 130.954)"
          fill="#EB5757"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M39.2684 154.543C58.955 160.358 60.4511 147.627 60.0988 143.682L85.7236 143.811L74.852 114.513L79.4165 114.42C79.4165 114.42 93.8497 136.576 98.2147 148.545C102.58 160.513 70.7607 158.67 70.7607 158.67L86.8525 221.354L52.4185 222.06C50.6658 222.096 34.6463 221.002 33.5204 219.689C33.5204 219.689 21.248 150.853 28.0323 144.994"
          fill="#EB5757"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M36.7429 125.17C36.7429 125.17 34.5865 127.597 41.9821 135.973L46.029 135.265L41.3742 122.476L36.7429 125.17"
          fill="#3F2C48"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.812 151.076C39.2532 151.328 39.6975 151.575 40.1471 151.814C47.3629 155.787 57.9422 152.262 57.4223 143.669L60.0988 143.682C60.4704 147.846 59.6509 151.599 56.5248 153.973C51.356 157.994 37.3661 161.372 27.0803 143.502L32.0282 143.781L38.812 151.076Z"
          fill="#FFFFFE"
        />
        <path
          d="M32.0164 143.69L57.4224 143.669C57.9423 152.262 42.3276 160.318 32.0164 143.69Z"
          fill="#F9B6A8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M42.7659 145.063L41.3726 134.478C41.3726 134.478 37.8507 132.804 38.65 131.038C39.4492 129.272 42.6059 132.093 42.6059 132.093L43.3263 132.078C43.3263 132.078 41.1706 124.323 40.3015 123.991L45.7645 122.386C45.7645 122.386 47.0495 122.746 48.3387 126.269C49.6277 129.791 53.046 136.165 51.3439 137.344C49.6422 138.522 48.4485 138.858 48.4485 138.858L50.6513 145.404L42.7659 145.063"
          fill="#F9B6A8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M40.3013 123.991C40.3013 123.991 46.5515 124.449 46.8349 121.117C47.1185 117.784 44.3417 116.282 42.0161 116.642C39.6907 117.001 39.1811 119.398 39.1811 119.398C39.1811 119.398 33.3159 121.082 36.7425 125.17L40.3013 123.991"
          fill="#3F2C48"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.3295 131.685L48.1792 132.199C48.1792 132.199 46.3964 128.663 47.2627 128.58C48.1291 128.498 49.3295 131.685 49.3295 131.685"
          fill="#CC395D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M45.0582 128.615C44.8926 128.304 44.5186 128.158 44.2235 128.29C43.9281 128.422 43.8232 128.781 43.9893 129.093C44.1549 129.404 44.5288 129.55 44.8239 129.418C45.119 129.286 45.2239 128.927 45.0582 128.615"
          fill="#3A3B39"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.2746 126.967C49.1089 126.656 48.735 126.51 48.4399 126.642C48.1445 126.774 48.0395 127.133 48.2056 127.445C48.3713 127.756 48.7452 127.902 49.0402 127.77C49.3353 127.638 49.4403 127.279 49.2746 126.967"
          fill="#3A3B39"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.5322 133.151C41.5728 133.15 41.6125 133.136 41.6436 133.108C41.7164 133.041 41.7146 132.921 41.6397 132.84C41.0742 132.232 40.3343 131.78 39.5555 131.568C39.4525 131.54 39.354 131.599 39.3379 131.7C39.3209 131.801 39.3918 131.906 39.4952 131.934C40.1973 132.125 40.8648 132.532 41.3746 133.082C41.4181 133.128 41.4768 133.152 41.5322 133.151"
          fill="#CC395D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M42.4323 127.477C42.563 127.475 42.6678 127.38 42.6784 127.246C42.7018 126.95 42.8875 126.703 43.1742 126.584C43.4654 126.463 43.7982 126.5 44.0658 126.682C44.2027 126.775 44.3762 126.747 44.4544 126.621C44.5329 126.494 44.4856 126.315 44.3491 126.223C43.9117 125.925 43.3734 125.862 42.9079 126.054C42.4472 126.244 42.1489 126.65 42.1105 127.139C42.0983 127.293 42.2154 127.443 42.3723 127.472C42.3929 127.476 42.4127 127.478 42.4323 127.477"
          fill="#3A3B39"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.7921 125.601C46.9198 125.598 47.0239 125.508 47.0379 125.377C47.0582 125.183 47.2175 124.996 47.4258 124.919C47.6316 124.844 47.8827 124.877 48.0372 125.001C48.1664 125.104 48.3442 125.091 48.4331 124.972C48.5229 124.854 48.4902 124.674 48.3606 124.571C48.0349 124.312 47.5718 124.237 47.1782 124.382C46.7891 124.525 46.5112 124.868 46.4709 125.256C46.4548 125.409 46.5684 125.561 46.7251 125.594C46.748 125.599 46.7702 125.601 46.7921 125.601"
          fill="#3A3B39"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.4068 134.178C50.6007 134.876 50.7119 135.959 49.6817 136.3C48.2707 136.768 47.3689 135.935 46.8709 135.195C48.0153 134.401 49.2047 134.143 50.4068 134.178"
          fill="#3A3B39"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.3854 134.25L50.1857 133.56C50.1857 133.56 50.3071 133.819 50.4068 134.178C49.2478 134.666 48.0584 134.923 46.871 135.195C46.5397 134.702 46.3854 134.25 46.3854 134.25"
          fill="#FFFFFE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.0549 143.632L51.0091 146.134L51.5126 143.64L50.0549 143.632"
          fill="#CC395D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.4485 138.858L46.6029 139.624L48.6917 139.581L48.4485 138.858"
          fill="#CC395D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M70.7607 158.67L68.3214 151.444L73.4357 158.616L70.7607 158.67"
          fill="#CC395D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M74.8516 114.513C74.8516 114.513 70.5578 114.809 70.5305 114.602L70.4213 113.772L73.5498 112.461L70.4478 105.352L73.968 104.666L79.4161 114.42L74.8516 114.513"
          fill="#F9B6A8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M85.7237 143.811L87.9492 148.963L82.1101 143.793L85.7237 143.811"
          fill="#CC395D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M52.6871 117.983L53.4647 118.563L57.7819 112.349L57.0042 111.769L52.6871 117.983"
          fill="#EB5757"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M55.8908 122.385L56.4024 123.207L64.5694 118.734L64.0577 117.912L55.8908 122.385"
          fill="#EB5757"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.479 128.327L58.6343 129.251L65.0074 128.886L64.8525 127.962L58.479 128.327"
          fill="#EB5757"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M76.4183 111.19L73.4669 112.282L73.633 112.64L76.5841 111.548L76.4183 111.19"
          fill="#CC395D"
        />
      </g>
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M76.4173 254.464L99.0694 254.464L103.694 227.105L74.2192 225.744L76.4173 254.464Z"
      fill="#FB9300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M103.011 231.149L103.694 227.105L74.2192 225.744L74.5627 229.836L103.011 231.149Z"
      fill="#F57100"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M71.5058 227.297L105.933 228.886L108.501 221.812L69.4408 220.009L71.5058 227.297Z"
      fill="#FB9300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M72.0412 209.34C73.4237 210.603 77.5349 220.383 77.5349 220.383L83.0464 220.637C83.0464 220.637 74.2594 197.694 66.6807 211.011C66.6807 211.011 70.6583 208.077 72.0412 209.34Z"
      fill="#008B44"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M113.686 207.186C113.686 207.186 109.192 216.09 99.1022 221.378L92.8718 221.091C92.8718 221.091 103.533 208.636 113.686 207.186Z"
      fill="#008B44"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M82.0977 220.594L86.1616 220.781C86.1616 220.781 82.4001 196.391 76.7633 181.746C76.7633 181.746 72.9952 206.027 82.0977 220.594Z"
      fill="#00A650"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M85.8157 220.765L90.4886 220.981C90.4886 220.981 96.704 192.976 85.1741 167.029C85.1741 167.029 81.7408 204.992 85.8157 220.765Z"
      fill="#008B44"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M117.314 170.191C104.267 182.17 112.328 200.17 92.8718 221.091L89.6366 220.941C96.1094 204.243 96.7432 178.832 117.314 170.191Z"
      fill="#00A650"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M173.721 189.477C173.221 189.851 154.983 187.706 154.983 187.706L149.748 168.617C149.315 167.04 150.539 165.497 152.173 165.559L172.963 166.345C174.034 166.386 174.95 167.125 175.216 168.163L179.762 185.902L189.062 187.706L173.721 189.477"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M156.965 185.673H177.37L173.339 168.731L152.367 168.267L156.965 185.673"
      fill="#FFFFFE"
    />
    <path
      d="M154.104 171.508C153.819 170.464 154.605 169.436 155.687 169.436H157.655C158.395 169.436 159.044 169.931 159.238 170.645V170.645C159.523 171.689 158.737 172.717 157.655 172.717H155.687C154.947 172.717 154.298 172.222 154.104 171.508V171.508Z"
      fill="#FFD0D0"
    />
    <path
      d="M155.297 175.387C155.012 174.343 155.798 173.314 156.88 173.314H158.849C159.588 173.314 160.237 173.809 160.432 174.523V174.523C160.716 175.567 159.93 176.596 158.849 176.596H156.88C156.14 176.596 155.492 176.101 155.297 175.387V175.387Z"
      fill="#F2F2F2"
    />
    <path
      d="M156.49 179.265C156.206 178.221 156.991 177.193 158.073 177.193H160.042C160.782 177.193 161.43 177.688 161.625 178.402V178.402C161.91 179.445 161.124 180.474 160.042 180.474H158.073C157.333 180.474 156.685 179.979 156.49 179.265V179.265Z"
      fill="#F2F2F2"
    />
    <path
      d="M157.684 183.144C157.399 182.1 158.185 181.071 159.267 181.071H161.235C161.975 181.071 162.624 181.566 162.818 182.28V182.28C163.103 183.324 162.317 184.353 161.235 184.353H159.267C158.527 184.353 157.878 183.857 157.684 183.144V183.144Z"
      fill="#F2F2F2"
    />
    <path
      d="M161.592 174.188C160.99 171.635 162.966 169.203 165.588 169.27L168.956 169.357C170.766 169.403 172.319 170.659 172.743 172.419L174.427 179.416C175.033 181.932 173.126 184.353 170.538 184.353H167.157C165.302 184.353 163.69 183.077 163.264 181.272L161.592 174.188Z"
      fill="#F2F2F2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M164.428 173.314C166.323 173.314 168.297 174.786 168.838 176.602C169.378 178.418 168.281 179.891 166.386 179.891C164.491 179.891 162.517 178.418 161.976 176.602C161.435 174.786 162.533 173.314 164.428 173.314Z"
      fill="#EB5757"
    />
    <path
      d="M163.573 175.578C163.476 175.185 163.774 174.806 164.179 174.806V174.806C164.466 174.806 164.717 175.002 164.785 175.282L165.283 177.315C165.379 177.708 165.081 178.088 164.677 178.088V178.088C164.389 178.088 164.139 177.891 164.07 177.612L163.573 175.578Z"
      fill="white"
    />
    <path
      d="M165.608 175.456C165.538 175.121 165.794 174.806 166.136 174.806V174.806C166.391 174.806 166.611 174.985 166.663 175.234L167.126 177.438C167.196 177.773 166.94 178.088 166.598 178.088V178.088C166.343 178.088 166.123 177.909 166.071 177.659L165.608 175.456Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M146.615 191.273H206.047C206.047 194.235 203.645 196.636 200.684 196.636H178.721L178.07 253.203L187.577 253.335C189.458 253.361 191.058 254.581 191.752 256.304H160.908C161.543 254.373 163.283 252.997 165.317 253.026L173.941 253.145L174.591 196.636H151.976C149.015 196.636 146.615 194.235 146.615 191.273Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M138.961 192.751H213.7V187.556H138.961V192.751Z"
      fill="#7DB1A1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M191.011 183.832C191.011 184.76 190.257 185.515 189.329 185.515H189.31V180.846H189.329C190.257 180.846 191.011 181.601 191.011 182.529V183.832ZM189.329 179.46H189.31V178.461H181.552V187.121C181.552 187.551 181.901 187.9 182.331 187.9H188.531C188.961 187.9 189.31 187.551 189.31 187.121V186.901H189.329C191.021 186.901 192.397 185.524 192.397 183.832V182.529C192.397 180.837 191.021 179.46 189.329 179.46V179.46Z"
      fill="#EB5757"
    />
    <g filter="url(#filter1_d_444_287)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M230.112 20.8078L152.476 24.8765C150.557 24.9771 148.952 26.4963 148.909 28.2526L147.965 66.3052C147.922 68.0615 149.456 69.4162 151.374 69.3157L229.011 65.2469C230.929 65.1464 232.534 63.6272 232.578 61.8709L233.521 23.8182C233.565 22.0619 232.031 20.7072 230.112 20.8078"
        fill="#FAFAFA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M162.873 31.088C167.727 30.8337 171.564 34.5666 171.443 39.4258C171.323 44.285 167.29 48.4304 162.436 48.6848C157.582 48.9391 153.745 45.2062 153.865 40.347C153.986 35.4878 158.019 31.3424 162.873 31.088Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M160.493 37.0659C160.496 36.9522 160.531 36.839 160.594 36.7399C160.778 36.453 161.149 36.3524 161.422 36.5152L165.859 39.1619C165.924 39.2004 165.979 39.2517 166.022 39.313C166.205 39.5726 166.13 39.948 165.856 40.1515L161.269 43.5592C161.167 43.635 161.046 43.6791 160.924 43.6855C160.595 43.7028 160.335 43.4497 160.343 43.1203L160.493 37.0659Z"
        fill="#FFFFFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.514 30.2683L191.921 29.5657C193.237 29.4967 194.278 30.509 194.245 31.8268C194.213 33.1445 193.119 34.2687 191.803 34.3377L178.396 35.0403C177.079 35.1093 176.039 34.097 176.071 32.7792C176.104 31.4615 177.198 30.3373 178.514 30.2683Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.277 39.8123L223.265 37.4546C224.582 37.3856 225.622 38.3979 225.589 39.7157C225.557 41.0334 224.463 42.1576 223.147 42.2266L178.159 44.5843C176.843 44.6533 175.802 43.6409 175.835 42.3232C175.868 41.0054 176.961 39.8813 178.277 39.8123Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M177.893 55.3213L222.881 52.9635C224.197 52.8946 225.238 53.9069 225.205 55.2246C225.172 56.5424 224.079 57.6666 222.762 57.7355L177.775 60.0932C176.458 60.1622 175.418 59.1499 175.45 57.8322C175.483 56.5144 176.577 55.3902 177.893 55.3213Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.085 47.5668L223.073 45.2091C224.389 45.1401 225.43 46.1524 225.397 47.4702C225.365 48.7879 224.271 49.9121 222.955 49.9811L177.967 52.3388C176.651 52.4078 175.61 51.3954 175.643 50.0777C175.675 48.7599 176.769 47.6358 178.085 47.5668Z"
        fill="#E7EFF1"
      />
    </g>
    <g filter="url(#filter2_d_444_287)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M261.14 37.8132L183.503 41.8819C181.585 41.9825 179.98 43.5017 179.936 45.258L178.993 83.3106C178.949 85.0669 180.483 86.4216 182.402 86.3211L260.038 82.2523C261.957 82.1518 263.562 80.6326 263.605 78.8763L264.549 40.8236C264.592 39.0673 263.058 37.7126 261.14 37.8132"
        fill="#FAFAFA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.9 48.0935C198.754 47.8391 202.591 51.572 202.471 56.4312C202.35 61.2904 198.318 65.4358 193.464 65.6902C188.61 65.9445 184.772 62.2116 184.893 57.3524C185.013 52.4932 189.046 48.3478 193.9 48.0935Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M191.52 54.0713C191.523 53.9576 191.558 53.8444 191.622 53.7453C191.806 53.4584 192.176 53.3578 192.449 53.5206L196.887 56.1673C196.951 56.2058 197.006 56.2571 197.049 56.3184C197.232 56.578 197.158 56.9534 196.884 57.1569L192.297 60.5645C192.194 60.6404 192.074 60.6845 191.951 60.6909C191.622 60.7082 191.362 60.4551 191.37 60.1257L191.52 54.0713Z"
        fill="#FFFFFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M209.541 47.2737L222.948 46.5711C224.265 46.5021 225.305 47.5144 225.273 48.8322C225.24 50.1499 224.146 51.2741 222.83 51.3431L209.423 52.0457C208.107 52.1147 207.066 51.1024 207.099 49.7846C207.132 48.4669 208.225 47.3427 209.541 47.2737Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M209.305 56.8177L254.293 54.46C255.609 54.391 256.65 55.4033 256.617 56.7211C256.584 58.0388 255.491 59.163 254.174 59.232L209.187 61.5897C207.87 61.6587 206.83 60.6463 206.862 59.3286C206.895 58.0109 207.989 56.8867 209.305 56.8177Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M208.92 72.3267L253.908 69.969C255.225 69.9 256.265 70.9123 256.232 72.23C256.2 73.5478 255.106 74.672 253.79 74.7409L208.802 77.0986C207.486 77.1676 206.445 76.1553 206.478 74.8376C206.511 73.5198 207.604 72.3956 208.92 72.3267Z"
        fill="#E7EFF1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M209.113 64.5722L254.1 62.2145C255.417 62.1455 256.457 63.1578 256.425 64.4756C256.392 65.7933 255.298 66.9175 253.982 66.9865L208.994 69.3442C207.678 69.4132 206.637 68.4008 206.67 67.0831C206.703 65.7653 207.796 64.6412 209.113 64.5722Z"
        fill="#E7EFF1"
      />
    </g>
    <g filter="url(#filter3_d_444_287)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M291.256 62.2157L213.619 66.2845C211.701 66.385 210.096 67.9042 210.052 69.6605L209.109 107.713C209.065 109.469 210.599 110.824 212.518 110.724L290.154 106.655C292.073 106.554 293.678 105.035 293.722 103.279L294.665 65.2262C294.708 63.4699 293.174 62.1152 291.256 62.2157"
        fill="#FFFFFE"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M224.016 72.496C228.87 72.2416 232.708 75.9746 232.587 80.8337C232.467 85.6929 228.434 89.8383 223.58 90.0927C218.726 90.3471 214.889 86.6142 215.009 81.755C215.13 76.8958 219.162 72.7504 224.016 72.496Z"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M221.722 78.3216C221.725 78.2079 221.76 78.0947 221.824 77.9956C222.008 77.7087 222.378 77.6081 222.651 77.7709L227.088 80.4176C227.153 80.4561 227.208 80.5074 227.251 80.5687C227.434 80.8283 227.36 81.2037 227.086 81.4073L222.498 84.8149C222.396 84.8907 222.276 84.9348 222.153 84.9412C221.824 84.9585 221.564 84.7054 221.572 84.376L221.722 78.3216Z"
      fill="#FFFFFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M239.658 71.6763L253.065 70.9737C254.381 70.9047 255.422 71.917 255.389 73.2347C255.356 74.5525 254.263 75.6767 252.946 75.7456L239.539 76.4483C238.223 76.5173 237.182 75.5049 237.215 74.1872C237.248 72.8694 238.341 71.7453 239.658 71.6763Z"
      fill="#E7EFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M239.421 81.2202L284.409 78.8625C285.725 78.7936 286.766 79.8059 286.733 81.1236C286.7 82.4414 285.607 83.5655 284.29 83.6345L239.303 85.9922C237.986 86.0612 236.946 85.0489 236.978 83.7312C237.011 82.4134 238.105 81.2892 239.421 81.2202Z"
      fill="#E7EFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M239.037 96.7292L284.024 94.3715C285.341 94.3025 286.381 95.3148 286.349 96.6326C286.316 97.9503 285.222 99.0745 283.906 99.1435L238.918 101.501C237.602 101.57 236.561 100.558 236.594 99.2401C236.627 97.9224 237.72 96.7982 239.037 96.7292Z"
      fill="#E7EFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M239.229 88.9747L284.217 86.617C285.533 86.548 286.574 87.5604 286.541 88.8781C286.508 90.1959 285.415 91.32 284.098 91.389L239.111 93.7467C237.794 93.8157 236.754 92.8034 236.786 91.4856C236.819 90.1679 237.912 89.0437 239.229 88.9747Z"
      fill="#E7EFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M229.957 255.143C228.572 255.08 227.334 255.111 226.484 255.245C225.395 255.416 224.092 255.969 223.788 256.863C223.546 256.936 223.272 257.014 222.98 257.098L222.98 257.099C221.083 257.643 218.374 258.421 217.896 259.373C217.378 260.405 217.844 261.891 218.936 262.267C220.052 262.651 221.38 261.549 221.208 260.382C221.093 259.601 220.343 259.043 219.572 258.965L223.891 257.905C224.304 258.642 225.395 258.951 226.32 259.095C228.423 259.425 230.547 259.694 232.674 259.794L233.053 261.099C232.579 260.661 232.048 260.642 231.61 260.863C230.963 261.191 230.522 262.044 230.779 262.838C231.482 265.012 234.082 263.771 234.341 262.082C234.367 261.912 234.202 260.686 233.992 259.833C234.926 259.845 235.86 259.819 236.793 259.748L236.884 259.741C237.674 259.681 238.519 259.617 239.141 259.153C239.6 258.811 239.828 258.486 239.867 258.18L243.065 258.965C242.295 259.043 241.544 259.601 241.429 260.382C241.257 261.549 242.586 262.651 243.701 262.267C244.794 261.891 245.259 260.405 244.741 259.373C244.264 258.421 241.555 257.643 239.658 257.099L239.658 257.099C239.276 256.989 238.926 256.888 238.635 256.798C238.382 256.675 238.098 256.557 237.787 256.446L237.771 256.416C237.773 256.426 237.778 256.436 237.786 256.446C236.415 255.957 234.531 255.59 232.642 255.365V228.979C232.642 228.237 232.041 227.636 231.299 227.636C230.558 227.636 229.957 228.237 229.957 228.979V255.143Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M212.207 220.436C212.207 220.436 215.999 230.793 236.777 228.7C257.554 226.607 246.497 217.657 239.048 217.657C231.599 217.657 212.207 220.436 212.207 220.436"
      fill="#523B5D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M201.515 157.775C201.515 157.775 202.151 152.941 201.515 152.941C200.879 152.941 200.37 155.358 200.37 155.358C200.37 155.358 199.502 154.243 199.184 154.37C198.866 154.498 198.971 155.231 198.971 155.231C198.971 155.231 198.458 154.605 198.14 154.669C197.822 154.732 197.953 155.803 197.953 155.803C197.953 155.803 197.318 154.904 197.063 154.967C196.809 155.031 197.063 156.185 197.063 156.185C197.063 156.185 194.051 154.273 193.963 154.52C193.665 155.358 195.219 155.867 199.607 160.192L201.515 157.775Z"
      fill="#A76930"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M200.268 155.249L198.36 157.03L198.564 157.249L200.472 155.467L200.268 155.249"
      fill="#523B5D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M213.549 165.746L201.466 157.691L199.229 160.525L209.969 172.906L213.549 165.746"
      fill="#0080A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M197.886 251.668L201.019 259.276L192.367 257.784L195.947 255.472L193.411 250.475L197.886 251.668"
      fill="#008B44"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M213.509 250.805L216.839 259.196L208.809 258.13L211.778 256.132L208.809 250.805H213.509"
      fill="#008B44"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M204.852 218.981L214.974 252.137L208.809 251.532L191.399 216.165L204.852 218.981"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M250.991 207.365C250.991 207.365 249.648 227.503 228.466 225.265C207.284 223.028 189.383 219.597 189.383 219.597L199.825 253.16L192.665 251.519C192.665 251.519 171.781 214.355 179.538 208.249C187.295 202.144 212.952 204.829 212.952 204.829L250.991 207.365"
      fill="#523B5D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M235.582 121.85C235.582 121.85 231.029 121.963 228.372 124.824C225.715 127.684 224.028 129.01 224.096 129.756C224.164 130.502 225.612 131.26 225.612 131.26L226.225 135.653L229.746 136.879L230.776 144.376L241.665 146.166L238.796 133.712L239.61 124.386L235.582 121.85Z"
      fill="#A76930"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M236.037 124.62C236.037 124.62 234.068 126.653 233.046 129.309C232.024 131.965 227.963 134.018 225.613 131.26C225.613 131.26 220.671 135.113 222.604 138.856C224.693 142.898 226.333 143.48 228.438 142.898C232.855 140.658 234.606 130.341 234.606 130.341C234.606 130.341 237.059 128.298 237.876 129.932C238.694 131.566 235.322 133.201 235.322 133.201L236.328 135.511L237.67 136.021L239.103 135.276C239.103 135.276 243.191 125.539 239.103 122.985C235.015 120.431 235.309 121.552 235.322 121.701C235.433 122.985 237.876 123.342 236.037 124.62Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M225.204 131.056C225.204 131.056 228.107 132.209 227.376 137.9C227.376 137.9 222.342 133.814 225.204 131.056"
      fill="#585755"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M230.211 127.225C230.211 126.802 229.868 126.458 229.445 126.458C229.021 126.458 228.678 126.802 228.678 127.225C228.678 127.648 229.021 127.991 229.445 127.991C229.868 127.991 230.211 127.648 230.211 127.225"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M234.784 132.014C234.74 132.014 234.696 131.997 234.663 131.963C234.598 131.897 234.6 131.79 234.666 131.725C235.26 131.147 236.001 130.741 236.808 130.551C236.897 130.53 236.989 130.586 237.01 130.677C237.031 130.767 236.975 130.858 236.885 130.879C236.137 131.055 235.451 131.431 234.901 131.966C234.868 131.998 234.826 132.014 234.784 132.014"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M231.29 126.51C231.158 126.51 231.047 126.407 231.038 126.273C231.018 125.96 230.824 125.655 230.52 125.457C230.215 125.259 229.857 125.205 229.563 125.313C229.432 125.362 229.287 125.294 229.239 125.163C229.191 125.032 229.258 124.887 229.389 124.839C229.833 124.676 230.359 124.749 230.796 125.034C231.233 125.319 231.512 125.77 231.542 126.241C231.551 126.38 231.446 126.5 231.306 126.509C231.301 126.51 231.295 126.51 231.29 126.51"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M249.649 155.752C249.649 155.752 248.008 142.209 233.848 142.209C215.938 142.209 208.776 177.381 201.616 186.183L183.118 183.199L181.627 187.823C181.627 187.823 208.776 202.442 215.638 190.658L212.953 204.829C212.953 204.829 244.278 210.348 250.991 207.365C250.991 207.365 252.035 167.089 249.649 155.752"
      fill="#00AEC8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M215.637 190.658L223.394 177.68L214.657 195.834L215.637 190.658"
      fill="#0080A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M189.384 219.597L184.461 218.702L190.185 222.172L189.384 219.597"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M183.118 183.199L178.942 182.453L174.765 183.945V185.287H178.942L181.971 186.757L183.118 183.199"
      fill="#A76930"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M249.194 224.614C258.212 214.192 254.429 191.2 254.268 190.23C254.174 189.662 253.637 189.277 253.068 189.371C252.499 189.465 252.114 190.003 252.208 190.572C252.246 190.8 255.832 213.444 247.6 223.265C243.881 227.702 236.579 228.705 236.579 228.705C236.579 228.705 243.682 230.983 249.194 224.614"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M241.147 179.69C243.476 178.554 246.206 178.851 248.797 178.829C250.805 178.812 252.812 178.587 254.775 178.158C255.783 177.938 256.87 177.67 257.816 178.086C259.122 178.662 259.575 180.26 259.82 181.667C260.271 184.254 260.54 186.918 260.05 189.497C258.045 200.051 240.73 198.156 237.622 189.351C236.362 185.816 237.774 181.334 241.147 179.69"
      fill="#523B5D"
    />
    <defs>
      <filter
        id="filter0_d_444_287"
        x="0.408386"
        y="20.9631"
        width="281.049"
        height="194.112"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="15" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_444_287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_444_287"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_444_287"
        x="117.964"
        y="0.802505"
        width="145.558"
        height="108.518"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="15" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_444_287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_444_287"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_444_287"
        x="148.992"
        y="17.8079"
        width="145.558"
        height="108.518"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="15" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_444_287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_444_287"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_444_287"
        x="179.108"
        y="42.2105"
        width="145.558"
        height="108.518"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="15" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_444_287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_444_287"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
